import { PlusOutlined, SyncOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Space,
  Select,
  Divider,
  Modal,
  Form,
  Input,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { AppDispatch } from "../helpers/appDispatch";
import { useDispatch } from "react-redux";
import { appSelector } from "../helpers/appSelector";
import { createHall, getHalls } from "../store/halls";
import HallsList from "../components/halls/HallsList";
import { Hall, CreateHallPayload } from "../interfaces";
import CreateHallForm from "../components/halls/CreateHallForm";

const Halls = () => {
  const dispatch: AppDispatch = useDispatch();

  const { school } = appSelector((state) => state.schoolStore);

  const [form] = Form.useForm();

  useEffect(() => {
    school?.id && dispatch(getHalls(school?.id?.toString()));
  }, [dispatch, school?.id]);

  const [filteredHalls, setFilteredHalls] = useState<Hall[]>([]);

  const { halls, loading, isHallSubmitting, success } = appSelector(
    (state) => state.hallsStore
  );

  useEffect(() => {
    setFilteredHalls(halls);
  }, [halls]);

  useEffect(() => {
    form.resetFields();
    success && onCloseModal();
  }, [success]);

  const initialValues: CreateHallPayload = {
    name: "",
    contact: "",
    description: "",
    school_id: school?.id?.toString() || "",
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOnFinish = (values: CreateHallPayload) => {
    values.school_id = school?.id?.toString() || "";
    dispatch(createHall(values));
  };

  const onSearch = (value: string) => {
    let filtered = halls.filter(
      (hall: Hall) =>
        hall.name.toLowerCase().includes(value.toLowerCase()) ||
        hall.contact?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredHalls(filtered);
  };

  return (
    <>
      <Helmet>
        <title>Admissions Ghana | Halls Setup | Blocks</title>
      </Helmet>
      <div className="padding-box">
        <Content className="site-layout-background site-content">
          <div className="margin-top">
            <Row>
              <Col span={24} md={24} xs={24} sm={24}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setIsModalOpen(true)}
                >
                  Add Hall
                </Button>
                <Space wrap style={{ float: "right" }}>
                  <Input.Search
                    placeholder="Search by name / contact"
                    onKeyUp={(event) =>
                      onSearch((event.target as HTMLInputElement).value)
                    }
                  />
                  <Button
                    type="default"
                    onClick={() =>
                      school?.id && dispatch(getHalls(school.id.toString()))
                    }
                    icon={<SyncOutlined />}
                  >
                    Refresh List
                  </Button>
                </Space>
              </Col>
              <Divider />
            </Row>
          </div>
          <HallsList halls={filteredHalls} loading={loading} />
        </Content>
      </div>

      <CreateHallForm
        open={isModalOpen}
        onCancel={onCloseModal}
        loading={isHallSubmitting}
        form={form}
        initialValues={initialValues}
        onFinish={handleOnFinish}
      />
    </>
  );
};

export default Halls;
